/* DSL Sticky CTA — show on product pages after scrolling 60% past hero */
(function(){
  if (location.pathname.indexOf("/products/") !== 0) return;
  var hero = document.querySelector(".product__media") || document.querySelector(".product");
  if (!hero) return;
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      document.body.classList.toggle("dsl-show-sticky-cta", !e.isIntersecting);
    });
  }, {threshold: 0.4});
  io.observe(hero);
})();